var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70175 12.7018L14.7018 7.70175C14.8947 7.52632 15 7.2807 15 7C15 6.45614 14.5439 6 14 6C13.7193 6 13.4737 6.10526 13.2982 6.29825L8.29825 11.2982C8.10526 11.4737 8 11.7193 8 12C8 12.5439 8.45614 13 9 13C9.2807 13 9.52632 12.8947 9.70175 12.7018ZM14.7018 16.2982L9.70175 11.2982C9.52632 11.1053 9.2807 11 9 11C8.45614 11 8 11.4561 8 12C8 12.2807 8.10526 12.5263 8.29825 12.7018L13.2982 17.7018C13.4737 17.8947 13.7193 18 14 18C14.5439 18 15 17.5439 15 17C15 16.7193 14.8947 16.4737 14.7018 16.2982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left.62642699.svg";
export { ForwardRef as ReactComponent };